import type { Currency } from '@shared/contracts/enums'
import type { DashboardCurrencyOverview } from './dashboard.contract'

export function emptyCurrencyOverview(currency: Currency): DashboardCurrencyOverview {
  const money = { amount: '0.000', currency }
  const metric = { value: money }
  const source = { gross: money, net: money, charges: 0 }
  const loss = { amount: money, count: 0, ratePct: 0 }
  const origin = { amount: money, salesCount: 0, pct: 0 }
  return {
    indicators: {
      salesCount: { value: 0 },
      chargeCount: { value: 0 },
      cardApprovalPct: { value: 0 },
      refundRatePct: { value: 0 },
      chargebackRatePct: { value: 0 },
    },
    grossSalesSeries: [],
    awardContribution: money,
    faturamento: { bruto: money, liquido: metric, taxas: money },
    recebido: metric,
    ticketMedio: metric,
    revenueSeries: [],
    topProducts: [],
    payMethods: [],
    pendingPix: { count: 0, amount: money },
    originBreakdown: { direct: origin, affiliate: origin, topAffiliates: [] },
    statesRanking: [],
    financial: {
      sources: {
        oneTime: source,
        subscriptionInitial: source,
        renewals: source,
        subscriptions: source,
        total: source,
      },
      losses: {
        refunds: loss,
        preventedRefunds: loss,
        chargebacks: loss,
        chargebackFees: { count: 0, generated: money, paid: money },
        total: money,
      },
      result: money,
    },
  }
}
